import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';

import {
  selectIsSidebarOpen,
  toggleSidebar,
  setSidebarOpen,
} from '@/store/global/globalSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  DrawerAppstore,
  useWindowSize,
} from '@data-products-and-ai/react-components';
import { DrawerOptionsProps } from '@data-products-and-ai/react-components/lib/components/Navigation/DrawerAppstore/DrawerAppstore';
import { SIDEBAR_SMALL_WIDTH, SIDEBAR_WIDTH, TABLET_WIDTH } from '@/constants';
import { useMsal } from '@azure/msal-react';

import '@/components/Sidebar/Sidebar.scss';

export const Sidebar = () => {
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { instance } = useMsal();

  const { width } = useWindowSize();
  const isMobile = width <= TABLET_WIDTH;

  const handleToggleOpen = () => {
    dispatch(toggleSidebar());
  };

  const handleNavigation = (path: string) => () => {
    navigate(path);

    if (isMobile && isSidebarOpen) {
      dispatch(toggleSidebar());
    }
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const options: DrawerOptionsProps[] = [
    {
      title: 'Home',
      icon: 'IconHome',
      onClick: handleNavigation('/'),
      isSelected: pathname === '/',
    },
    {
      title: 'Outages',
      icon: 'IconData',
      onClick: handleNavigation('/outages'),
      isSelected: pathname.startsWith('/outages'),
    },
    {
      title: 'Millwrights',
      icon: 'IconUser',
      onClick: handleNavigation('/millwrights'),
      isSelected: pathname === '/millwrights',
    },
    {
      title: 'Logout',
      icon: 'IconLogout',
      onClick: handleLogout,
    },
  ];

  useEffect(() => {
    if (isMobile && isSidebarOpen) {
      dispatch(setSidebarOpen(false));
    }
    if (!isMobile && !isSidebarOpen) {
      dispatch(setSidebarOpen(true));
    }
  }, [isMobile, toggleSidebar, dispatch]);

  return (
    <div className="sidebar-container">
      <DrawerAppstore
        width={!isSidebarOpen ? SIDEBAR_SMALL_WIDTH : SIDEBAR_WIDTH}
        isOpen={isSidebarOpen}
        options={options}
        setIsOpen={handleToggleOpen}
        offsetTop={71.1}
      />
    </div>
  );
};
